export default {
  'Download Mobile App': 'アプリをダウンロード',
  'Buy Now': '今すぐ購入',
  'Contact Us': 'お問い合わせ',
  'Copyright @ 2020, Famikit.com. All rights reserved.': 'Copyright @ 2020, Famikit.com. All rights reserved.',
  'Welcome to FamiKit': 'FamiKit へようこそ',
  'Sign in': 'サインイン',
  'Home': 'ホーム',
  'Sreen Time': 'スクリーンタイム',
  'Apps Time': 'アプリの使用状況',
  'Website Filter': 'ウェブサイトフィルター',
  'Geofences': 'ジオフェンス',
  'Notifications': '通知',
  'My': 'アカウント',
  'Screen time': 'スクリーンタイム',
  'Most apps used': '最も使用されたアプリ',
  'No data display': 'データが見つかりませんでした',
  "You have not installed Famikit on your child's phone. After installation, you can reopen Famikit on this device to see the statistics of children's mobile phones.": "お子様の携帯に FamiKit をインストールしていません。インストール後、FamiKit を再度開くことができます。このデバイスでお子様の携帯のデータを確認してください。",
  'What should I do ?': '何をすべきか？',
  "1. Get the child's cell phone": "1. 子供の携帯を入手する",
  '2. Open Google play, search and install famikit': '2. Google Play を開き、FamiKit を検索してインストールする',
  '3. Clock in famikit and log in（ {email} ）, select role child': '3. FamiKit を起動して( {email} )でログインし、お子様の役割を選択する',
  '4. Follow the instructions in famikit to set permissions': "4. FamiKit の指示に従って権限を設定する",
  'Name': '名前',
  'Used time': '使用時間',
  'Limit duration': '制限期間',
  'Restricted period': '制限された期間',
  'Limit set': '制限の設定',
  'Set App usage time': 'アプリの使用時間の設定',
  'Limit wechat usage time': 'WeChat の使用時間を制限する',
  'Note: set the maximum time that the app can be used': '注意：アプリを使用できる最大時間を設定する',
  'Repeat': '繰り返し',
  'Save': '保存',
  'Cancel': 'キャンセル',
  'hour': '時間',
  'min': '分',
  'Set app usage period': 'アプリの使用期間の設定',
  'Start': '開始',
  'End': '終了',
  'Limit Screen usage time': '画面使用時間を制限する',
  'Limited to {time} hours per day': '1日あたり {time} に制限する',
  'Set screen usage time': '画面使用時間の設定',
  'Set exception app': '例外アプリの設定',
  'Limit screenusage time': '画面使用時間を制限する',
  'Exception app can be used without time limit': '例外アプリは制限時間内に使用できます',
  'Email cannot be blank.': 'メールアドレスは空白にすることができません。',
  'Please enter a valid email address': '有効なメールアドレスを入力してください',
  "Password": "パスワード",
  "Repeat Password": "パスワードの確認",
  'I agree': '同意する',
  'User agreement': 'ユーザーの同意',
  'and': 'と',
  'Privacy policy': 'プライバシーポリシー',
  'Register': '登録',
  'Existing account?': '既にアカウントを持っている？',
  'Password cannot be blank.': 'パスワードを空白にすることはできません。',
  'Repeat Password cannot be blank.': '確認パスワードは空白にすることができません。',
  'The two passwords you entered do not match.': 'ご入力になる2つのパスワードが一致しません。',
  'Please read and agree to the terms of service first.': 'まず利用規約を読んで同意してください。',
  'Username already exists.': 'ユーザー名はすでに存在しています。',
  'unexpected error.': '予期しないエラーが発生しました。',
  'Email': 'Eメール',
  'Network delay, please try again.': 'ネットワークの遅延が発生しました。再試行してください。',
  'Incomplete parameters.': '不完全なパラメータです。',
  'Username does not exist.': 'ユーザー名が存在しません。',
  'Incorrect username or password.': 'ユーザー名またはパスワードが正しくありません。',
  'Return': '戻る',
  'Choose your subscription plan and get started': 'サブスクリプションプランを選択して開始してください',
  "Note: the number of devices refers to the number of children's devices that can be bound. Binding is to access your child's device and install it from Google play.": "注意：デバイス数とは、子供用バインド可能なデバイスの数を意味します。お子様のデバイスにアクセスし、Google Play から FamiKit をインストールする必要があります。",
  'Register now': '今すぐ登録',
  'No account?': 'アカウントを持っていない？',
  'Add to Cart': 'カートに追加',
  'Store': 'ストア',
  'MONTHLY': '月ごと',
  '$ 7.99 / Month': '$ 7.99 / 月',
  'Can be bound to': 'バインド可能',
  'devices': 'デバイス',
  '$ 5.99 / Month': '$ 5.99 / 月',
  '$ 4.99 / Month': '$ 4.99 / 月',
  'Subscribe': '購読',
  'QUARTERLY': '3ヶ月プラン',
  'ANNUAL': '年間プラン',
  'Note': '注意',
  'download New Version Note!': '新しいバージョンが利用可能になります。',
  'No': 'いいえ',
  'Yes': 'はい',
  'Account expired': 'アカウントの有効期限が切れました',
  'Account expired Please renew!': 'お使いのアカウントの有効期限が切れています。更新してください。',
  'New data is uploading, it may take a while.': '新しいデータをアップロードしています。少し時間がかかる場合があります。',
  "1. Get your kid's cell phone.": "1. お子様の携帯を入手する。",
  "2. Visit famikit.com in browser, download and install FamiKit App.": "2. ブラウザで famikit.com にアクセスし、FamiKit アプリをダウンロードしてインストールする。",
  "3. Open FamiKit app, sign in（ {email} ）and select kid's role.": "3. FamiKit アプリを開き、( {email} )でサインインし、子供の役割を選択する。",
  '4. Follow the instructions in FamiKit to set permissions.': '4. FamiKit の指示に従って設定する。',
  '5. Refresh this page.': '5. このページを更新してください。',
  'Refresh Now.': '今すぐ更新',
  'Limited to {time} per day': '1日あたり {time} に制限する',
  'Current account is not activated.': '現在のアカウントはアクティブ化されていません。',
  'About': '情報',
  'User privacy agreement': 'エンドユーザー使用許諾契約書',
  'No data found': 'データが見つかりませんでした',
  'Updated {times} ago': '{times} 前に更新しました',
  'No location information': '位置情報なし',
  'please wait...': 'お待ちください...',
  'Used for': '使用時間：',
  'Today': '今日',
  'Yesterday': '昨日',
  'Last 3 Days': '過去3日間',
  'Last 7 Days': '過去7日間',
  'Social contact': 'ソーシャルアプリ',
  'Other': 'その他',
  'Game': 'ゲーム',
  'Please confirm': '確認事項',
  '1. The childs mobile phone is connected to the Internet and the position switch is turned on.': "1. お子様の携帯電話がインターネットに接続されており、位置スイッチがオンになっていることを確認してください。",
  '2. Whether the famikit in the childs mobile phone is turned on.': "2. お子様の携帯に FamiKit がオンになっているかどうかを確認してください。",
  'OK': 'OK',
  'Valid until': 'サブスクリプションの有効期間の最終日',
  'Update subscription': 'サブスクリプションの更新',
  'kids equipment': "子供のデバイス",
  'Disconnect': '切断',
  'My Account': 'マイアカウント',
  'Sign out': 'サインアウト',
  'Cancel account': 'アカウントのキャンセル',
  'You will not be able to receive device status after disconnection. Are you sure you want to disconnect ?': '切断後はデバイスのステータスを受信できません。切断してもよろしいですか？',
  'Are you sure you want to exit ?': '本当に終了しますか？',
  'Warning: after the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?': '注意：アカウントがキャンセルされると、データは消去され、取得できなくなります。アカウントを削除してもよろしいですか？',
  'Delete all': 'すべて削除',
  'Mark all as read': 'すべて既読にする',
  'Limit time interval': '時間間隔の制限',
  'Set Time Limits': '制限時間の設定',
  'Set screen usage period': '画面使用期間の設定',
  'Set app time limit': 'アプリの時間制限の設定',
  'Limit usage period': '使用制限期間',
  'Monday': '月曜日',
  'Tuesday': '火曜日',
  'Wednesday': '水曜日',
  'Thursday': '木曜日',
  'Friday': '金曜日',
  'Saturday': '土曜日',
  'Sunday': '日曜日',
  'Add exception': '例外を追加',
  'Search locations': '場所を検索',
  'Rule': 'ルール',
  'Prevent': '禁止',
  'Allow': '許可',
  'Website filtering': 'ウェブサイトフィルター',
  'Customize site access, block or allow': 'サイトアクセス、ブロックまたは許可をカスタマイズする',
  'Are you sure you want to delete the filter settings ?': 'フィルター設定を削除してもよろしいですか？',
  'Filtering web browser access by category and URL': 'カテゴリと URL による Web ブラウザアクセスをフィルタリングする',
  '（Only Chrome browser is supported）': '(Chrome ブラウザーのみがサポートされています)',
  '$ {Month} / Month': '$ {Month} / 月',
  'Radius of the geofence in meters ({0}) m max.': 'ジオフェンスの半径が最大 ({0}) m。',
  'Out': '離れる',
  'In': '到着',
  'search': '検索',
  'Name the Geofence': 'ジオフェンスに名前を付ける',
  'NameBeBlank': '名前を空白にすることはできません',
  'Radius of the geofence in meters （1000m max.）': 'ジオフェンスの半径が (最大1000m)。',
  'Are you sure you want to select the deleted geofence': '選択されたジオフェンスを削除してもよろしいですか？',
  'Most Used': '最も使用されている',
  'Set Limits': '制限の設定',
  'Limit Screen Time': 'スクリーンタイムの制限',
  'Allow: {time} ': '許可: {time} ',
  'Downtime': 'ダウンタイム',
  'Note: This is the maximum time that kid’s phone can be used.': 'ご注意：これは、お子様のスマホを使用できる最大時間です。',
  'Always Allowed': '常に許可',
  'Choose apps that your kids can use all the time.': 'お子様がいつでも使用できるアプリを選択してください。',
  'Duration Limit': '期間制限',
  'Customize site access: Prevent or Allow.': 'サイトアクセスのカスタマイズ：禁止または許可。',
  'Enter URL': 'URL を入力する',
  'Restriction': '制限',
  'Exception': '例外',
  'Adult': 'アダルトコンテンツ',
  'Alcohol': 'アルコール & タバコ',
  'Anonymizers': 'アノニマイザー',
  'Gambling': 'ギャンブル',
  'Games': 'ゲーム',
  'Job': '仕事',
  'Music': 'ミュージック & ビデオ',
  'News': 'ニュース媒体',
  'Profanity': '冒涜',
  'Religions': '宗教',
  'Search': '検索',
  'Shopping': 'ショッピング',
  'Social': 'ソーシャルアプリ',
  'Unknown': '未知',
  'Violence': '暴力',
  'Weapons': '武器',
  'Try it now': '今試してみて',
  // 12.14新增
  'Your kid cannot use the device during the time limit.': '制限時間内はお子様はデバイスを使用できません。',
  // 7、26新增
  'famiKit（ {ver} ）is now available for your kid. Please go toGoogle Play Store and install the latest version of Famikit on yourkid’s device': "FamiKit（{ver}）がお子様にご利用いただけるようになりました。 Google Playストアにアクセスして、お子様のデバイスに最新バージョンのFamiKitをインストールしてください。",
  'famikit（ {ver} ）is now available for your kid. Please go to': 'FamiKit（{ver}）がお子様にご利用いただけるようになりました。に行ってください',
  'famikit.com': 'famikit.com',
  'and install the latest version of Famikit for PC on yours device': 'PC用のFamiKitの最新バージョンをデバイスにインストールします。',
  '3. Open FamiKit app, sign in（ {email} ）': '3. FamiKitアプリを開き、サインインします（{email}）',
  'Kid device is Android': 'お子様のデバイスはAndroidです',
  'Kid device is Windows': 'お子様のデバイスはWindowsです',
  '2. Visit famikit.com in browser, download and install Famikit App.': '2.ブラウザでfamikit.comを開き、FamiKitアプリをダウンロードしてインストールします。',
  "1. Get your kid's PC": "1.お子様のPCに移動します",
  '2. Download FamiKit android app from Google Play': '2. Google PlayストアからFamiKitのAndroidアプリをダウンロードします',
  'Browser Histroy': 'ブラウザの履歴',
  'Enable Brower History': 'ブラウザの履歴を有効にする',
  'After opening, it will record the browsing records of chrome, Firefox, edge and other browsers.': 'このオプションを有効にすると、Chrome、Firefox、Edge、その他のブラウザの閲覧履歴が記録されます。'
}




// WEBPACK FOOTER //
// ./src/language/ja.js